






























import { Component, Vue } from "vue-property-decorator";
import { Cell, Button } from "vant";
import CustomSelect from "../components/CustomSelect.vue";

@Component({
  components: {
    [Cell.name]: Cell,
    customSelect: CustomSelect,
    [Button.name]: Button
  }
})
export default class Derivative extends Vue {
  list = [
    {
      label: "本人是否曾接受有关衍生品的培训或修读香港课程",
      value: "",
      options: [
        {
          text: "是",
          value: 1
        },
        {
          text: "否",
          value: 2
        }
      ]
    },
    {
      label: "请问您是否在现时或过去拥有与衍生产品有关的工作经验",
      value: "",
      options: [
        {
          text: "是",
          value: 1
        },
        {
          text: "否",
          value: 2
        }
      ]
    },
    {
      label:
        "本人在过去三年曾执行过五次或以上有关任何衍生产品(不论是否在交易所买卖)的交易",
      value: "",
      options: [
        {
          text: "是",
          value: 1
        },
        {
          text: "否",
          value: 2
        }
      ]
    }
  ];
  financeList = {};
  investmentList = {};

  get isSubmitDisabled() {
    const res = this.list.every(item => {
      return item.value;
    });
    return !res;
  }

  handleSaveExamine() {
    const financeList = window.sessionStorage.getItem("financeList") || "";
    const investmentList =
      window.sessionStorage.getItem("investmentList") || "";

    (this as any).$apis
      .saveExamine({
        examine_list: {
          financeList: JSON.parse(financeList),
          investmentList: JSON.parse(investmentList),
          derivativeList: this.list
        }
      })
      .then(res => {
        this.$router.push({
          path: "/risk-disclosure",
          query: this.$route.query
        });
        
      })
      .catch(e => {
        
      });
  }
}
